// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

.kixVT{
  background-color:#0074c2;
  border:solid 2px #0074c2;
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.pi31p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.atjTA {
  padding: 0 !important;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.dx5Wq {
  position: relative;
  right: 0;
  display: inline-block;
  padding: 5px
}

.GIL3l {
  padding: 0 !important;
}

.acENk {
  padding-left: 10px;
  padding-right: 10px;
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;
  /* text-align will align the inline-block componenets to center */
  text-align: left;
}

.tEs46 {
  font-family: Oswald;
  font-size: 30px;
  line-height: 32px;
  text-transform: uppercase;
  color: #0074c2;
}

.hfhjD {
  padding-left: 10px;
  padding-right: 10px;
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;
  font-style: normal !important;
  color: #3d3d3d;
  font-family: Oswald, sans-serif !important;
  font-size: 20px !important;
  line-height: 30.8px !important;
  text-align: center;
}

.LNijR {
  margin-top: 20px;
}

.LNijR {
  padding-left: 10px;
  padding-right: 10px;
}

.Jfh9R {
  display: block;
  border-bottom: 1px solid #9bcbec;
  color: #0074c2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Jfh9R:hover {
  color: white;
  background-color: #0074c2;
  padding-left: 5px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publicationButton": `kixVT`,
	"root": `pi31p`,
	"container": `atjTA`,
	"buttonContainer": `dx5Wq`,
	"contentPageCustom": `GIL3l`,
	"allNewsSection": `acENk`,
	"sectionTitle": `tEs46`,
	"noNewsTitle": `hfhjD`,
	"oldNewsSection": `LNijR`,
	"oldNewsLink": `Jfh9R`
};
module.exports = ___CSS_LOADER_EXPORT___;
